import { render, staticRenderFns } from "./teilnehmer-person-list.vue?vue&type=template&id=bad72d76&scoped=true"
import script from "./teilnehmer-person-list.vue?vue&type=script&lang=js"
export * from "./teilnehmer-person-list.vue?vue&type=script&lang=js"
import style0 from "./teilnehmer-person-list.vue?vue&type=style&index=0&id=bad72d76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad72d76",
  null
  
)

export default component.exports